import { PageViewEventLogger } from '@repo/tracking-service';
import { ReactElement } from 'react';

import { LocationMoveYearContainer } from '@/components/survey/business/first-location/LocationMoveYearContainer';
import { BusinessProvider } from '@/components/survey/common/BusinessProvider';
import { LocationProvider } from '@/components/survey/common/LocationProvider';
import { SurveyProvider } from '@/components/survey/common/SurveyProvider';
import { useSurveyUserEventAttributes } from '@/components/survey/common/hooks/use-survey-user-event-attributes';

function LocationMoverYearPage() {
  const eventAttributes = useSurveyUserEventAttributes();

  return (
    <PageViewEventLogger pageName={'survey_relocation-address'} eventProperty={eventAttributes}>
      <LocationMoveYearContainer />
    </PageViewEventLogger>
  );
}

LocationMoverYearPage.getLayout = (page: ReactElement) => (
  <SurveyProvider>
    <BusinessProvider>
      <LocationProvider>{page}</LocationProvider>
    </BusinessProvider>
  </SurveyProvider>
);

export default LocationMoverYearPage;
